// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.search_container {
    display: flex;
    align-items: center;
    gap: 10px;
    background-color: #2e374a;
    padding: 10px;
    border-radius: 10px;
    width: max-content;
  }
  
  .search_input {
    background-color: transparent;
    border: none;
    color: var(--text);
    outline: none;
  }`, "",{"version":3,"sources":["webpack://./src/components/search/search.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;IAClB,aAAa;EACf","sourcesContent":[".search_container {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background-color: #2e374a;\n    padding: 10px;\n    border-radius: 10px;\n    width: max-content;\n  }\n  \n  .search_input {\n    background-color: transparent;\n    border: none;\n    color: var(--text);\n    outline: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
